<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Criar Pesquisa</div>
          </div>
          <div class="card-body">
            <!-- Form -->
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label>Nome</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="research.name"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Ciclo</label>
                  <select class="form-control" v-model="research.cycle_id">
                    <option
                      v-for="cycle in cycles"
                      :value="cycle.id"
                      :key="cycle.id"
                    >
                      {{ cycle.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label>Nível de Anonimidade</label>
                  <select
                    class="form-control"
                    v-model="research.anonymity_level"
                  >
                    <option
                      v-for="anonymity_level in anonymity_levels"
                      :value="anonymity_level.id"
                      :key="anonymity_level.id"
                    >
                      {{ anonymity_level.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="card-header">
                  <div class="card-title">Configurações dos Períodos</div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="card-subtitle mb-1">Aplicação</div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Início</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 1"
                        v-model="research.apply_start_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Término</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 2"
                        v-model="research.apply_end_date"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card-subtitle mb-1">Análise</div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Início</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 3"
                        v-model="research.analisys_start_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Término</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 4"
                        v-model="research.analisys_end_date"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card-subtitle mb-1">Divulgação</div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Início</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 5"
                        v-model="research.disclosure_start_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Término</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 6"
                        v-model="research.disclosure_end_date"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card-subtitle mb-1">Plano de Ação</div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Início</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 7"
                        v-model="research.action_start_date"
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Término</label>
                      <input
                        class="form-control"
                        type="datetime-local"
                        :disabled="research.status_id >= 8"
                        v-model="research.action_end_date"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card-header">
                  <div class="card-title">Configurações da Pesquisa</div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="card-subtitle mb-1">
                      Labels das perguntas de escala
                    </div>
                    <div class="row">
                      <div
                        class="col-6 mt-3"
                        v-for="scaleOption in scaleOptions"
                        :key="scaleOption.number"
                      >
                        <div class="row">
                          <div class="col-2 text-right">
                            <span class="scale-config-number">{{
                              scaleOption.number
                            }}</span>
                          </div>
                          <div class="col-md-10 pl-0">
                            <input
                              type="text"
                              class="form-control"
                              v-model="scaleOption.label"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-md-12">
                    <div class="form-group h-100">
                      <div class="card-subtitle mb-1">
                        Texto de explicação ao colaborador no início da pesquisa
                      </div>
                      <ckeditor
                        :editor="editor"
                        v-model="research.presentation_text"
                      ></ckeditor>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 d-flex align-items-end">
                  <div class="row">
                    <div class="custom-control custom-switch">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="customSwitch1"
                        v-model="research.select_essay"
                      />
                      <label class="custom-control-label" for="customSwitch1"
                        >Deseja visualizar o Gráfico de Respostas Dissertativas
                        nessa pesquisa?</label
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <div v-if="preMadeResearches.length">
              <h5>
                Para facilitar, temos algumas pesquisas pré-feitas com perguntas
                selecionadas pela nossa equipe de RH, de acordo com alguns
                temas:
              </h5>
              <div class="row">
                <div class="col-md-3">
                  <select
                    class="form-control"
                    v-model="selectedPreMadeResearch"
                    @change="preMadeResearchChanged"
                  >
                    <option value>Selecione aqui uma pesquisa pronta</option>
                    <option
                      v-for="preMadeResearch in preMadeResearches"
                      :key="preMadeResearch.id"
                      :value="preMadeResearch.id"
                    >
                      {{ preMadeResearch.name }}
                    </option>
                  </select>
                </div>
              </div>
              <hr />
            </div>

            <ul class="nav nav-tabs" id="tabs" role="tablist">
              <li class="nav-item">
                <h5
                  class="nav-link active tab-selected"
                  id="questions-tab"
                  data-toggle="tab"
                  href="#questions"
                  role="tab"
                  aria-controls="questions"
                  aria-selected="true"
                >
                  Perguntas
                </h5>
              </li>
              <li class="nav-item">
                <h5
                  class="nav-link tab-selected"
                  id="users-tab"
                  data-toggle="tab"
                  href="#users"
                  role="tab"
                  aria-controls="users"
                  aria-selected="false"
                >
                  Usuarios
                </h5>
              </li>
            </ul>
            <div class="tab-content" id="tabsContent">
              <div
                class="tab-pane fade show active"
                id="questions"
                role="tabpanel"
                aria-labelledby="questions-tab"
              >
                <base-crud
                  :ref="table"
                  :crudName="crudName"
                  :newText="newText"
                  :table="table"
                  :columns="columns"
                  :options="options"
                  :endPoint="endPoint"
                  :enableAdd="false"
                  :enableEdit="false"
                  :enableDelete="false"
                  :enableView="false"
                  :detailUrl="detailUrl"
                  @checkboxSelected="checkboxSelected"
                  :selectedCheckboxes="selectedAsks"
                ></base-crud>
              </div>
              <div
                class="tab-pane fade"
                id="users"
                role="tabpanel"
                aria-labelledby="users-tab"
              >
                <base-crud
                  :ref="table"
                  :crudName="crudUserName"
                  :newText="newText"
                  :table="user_table"
                  :columns="user_columns"
                  :options="user_options"
                  :endPoint="userEndPoint"
                  :enableAdd="false"
                  :enableEdit="false"
                  :enableDelete="false"
                  :enableView="false"
                  @checkboxSelected="checkboxUserSelected"
                  :selectedCheckboxes="selectedUsers"
                ></base-crud>
              </div>
            </div>
            <!-- Save -->
            <div class="row justify-content-end mt-4">
              <div class="col-md-6">
                <button class="btn btn-next btn-block" @click="save()">
                  Salvar
                  <i class="fas fa-save"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "./../Base/BaseCrud";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  data() {
    return {
      editor: ClassicEditor,
      editorData: "<p>Hello World ...</p>",
      dateTimePlaceholder: "Ex: " + moment().format("DD/MM/YYYY HH:mm"),
      preMadeResearches: [],
      getSelectedUsers: [],
      selectedPreMadeResearch: "",
      research: {
        name: "",
        cycle_id: "",

        apply_start_date: "",
        apply_end_date: "",
        analisys_start_date: "",
        analisys_end_date: "",
        disclosure_start_date: "",
        disclosure_end_date: "",
        action_start_date: "",
        action_end_date: "",
        presentation_text: "",
        anonymity_level: "",
        select_essay: 0,
      },
      scaleOptions: [
        {
          number: 0,
          label: "Não se aplica",
        },
        {
          number: 1,
          label: "Nunca é verdade",
        },
        {
          number: 2,
          label: "Na maioria das vezes não é verdade",
        },
        {
          number: 3,
          label: "Às vezes é verdade, às vezes não",
        },
        {
          number: 4,
          label: "Na maioria das vezes é verdade",
        },
      ],
      selectedAsks: [],
      selectedUsers: [],
      cycles: [],
      anonymity_levels: [],
      crudName: "Selecione as perguntas para a pesquisa",
      crudUserName: "Selecione os usuarios para a pesquisa",
      newText: "",
      table: "researchAsksTable",
      user_table: "userTable",
      user_columns: [
        "checkbox",
        "id",
        "name",
        "sector_id",
        "branch_id",
        "role_id",
      ],
      columns: ["checkbox", "id", "title", "dimension_id", "type_id"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        sortable: ["id", "title", "dimension_id", "type_id"],
        filterable: ["id", "title", "dimension_id", "type_id"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          checkbox: "Selecionado(s)",
          id: "ID",
          title: "Título",
          dimension_id: "Dimensão",
          type_id: "Tipo",
          actions: "Ações",
        },
        templates: {
          dimension_id(h, row, index) {
            return row.dimension.name;
          },
          type_id(h, row, index) {
            return row.type.name;
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["dimension", "type"];

          localStorage.setItem("url", this.url + "?" + query);
          localStorage.setItem("requestData", JSON.stringify(requestData));
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      user_options: {
        filterByColumn: true,
        debounce: 1000,
        sortable: ["id", "name", "branch_id", "sector_id", "role_id"],
        filterable: ["id", "name", "branch_id", "sector_id", "role_id"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          checkbox: "Selecionado(s)",
          name: "Nome",
          branch_id: "Unidade",
          sector_id: "Departamento",
          role_id: "Cargo",
          id: "ID",
        },
        templates: {
          company_id: function (h, row, index) {
            return row.company ? row.company.fantasy_name : "";
          },
          branch_id: function (h, row, index) {
            return row.branch ? row.branch.name : "";
          },
          sector_id: function (h, row, index) {
            return row.sector ? row.sector.name : "";
          },
          role_id: function (h, row, index) {
            return row.role ? row.role.name : "";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = ["company", "branch", "sector", "role"];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "researchasks/",
      userEndPoint: "users/",
      detailUrl: "ask",
    };
  },
  computed: {},
  methods: {
    preMadeResearchChanged() {
      this.selectedAsks = [];

      if (this.selectedPreMadeResearch) {
        let asksToSelect = [];

        let preMadeResearch = this.preMadeResearches.find(
          (x) => x.id == this.selectedPreMadeResearch
        );

        if (preMadeResearch) {
          // preMadeResearch.dimensions.forEach(dimension => {
          //     asksToSelect = [...asksToSelect, ...dimension.asks];
          // });

          this.selectedAsks = preMadeResearch.asks;
        }
      }
    },
    checkboxSelected: function (data) {
      const self = this;
      let row = data.row;
      let found = self.selectedAsks.find((x) => x.id === row.id);
      if (found) {
        let index = self.selectedAsks.findIndex((x) => x.id === row.id);
        self.selectedAsks.splice(index, 1);
      } else {
        self.selectedAsks.push(row);
      }
    },
    checkboxUserSelected: function (data) {
      const self = this;
      let row = data.row;
      let found = self.selectedUsers.find((x) => x.id === row.id);
      if (found) {
        let index = self.selectedUsers.findIndex((x) => x.id === row.id);
        self.selectedUsers.splice(index, 1);
      } else {
        self.selectedUsers.push(row);
      }
    },
    save() {
      const self = this;
      let api = self.$store.state.api + "researches/";
      if (self.research.id) {
        api += self.research.id;
      }
      const fd = self.makeFormData();
      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            "Pesquisa cadastrada com sucesso",
            "success"
          );
          self.$router.push("/researches");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    revertDateTime(dateTime) {
      if (dateTime) {
        return moment(dateTime).format("YYYY-MM-DDTHH:mm");
      } else {
        return "";
      }
    },
    formatDateTime(dateTime) {
      if (dateTime) {
        return moment(dateTime).format("YYYY-MM-DD HH:mm");
      } else {
        return "";
      }
    },
    makeFormData() {
      const self = this;
      const fd = new FormData();

      fd.append("name", self.research.name);
      fd.append("cycle_id", self.research.cycle_id);
      fd.append(
        "apply_start_date",
        self.formatDateTime(self.research.apply_start_date)
      );
      fd.append(
        "apply_end_date",
        self.formatDateTime(self.research.apply_end_date)
      );
      fd.append(
        "analisys_start_date",
        self.formatDateTime(self.research.analisys_start_date)
      );
      fd.append(
        "analisys_end_date",
        self.formatDateTime(self.research.analisys_end_date)
      );
      fd.append(
        "disclosure_start_date",
        self.formatDateTime(self.research.disclosure_start_date)
      );
      fd.append(
        "disclosure_end_date",
        self.formatDateTime(self.research.disclosure_end_date)
      );
      fd.append(
        "action_start_date",
        self.formatDateTime(self.research.action_start_date)
      );
      fd.append(
        "action_end_date",
        self.formatDateTime(self.research.action_end_date)
      );
      fd.append("presentation_text", self.research.presentation_text);
      fd.append("anonymity_level", self.research.anonymity_level);
      fd.append("select_essay", self.research.select_essay == false ? 0 : 1);

      self.selectedAsks.forEach((selectedAsk) => {
        fd.append("asks[]", selectedAsk.id);
      });

      self.selectedUsers.forEach((selectedUser) => {
        fd.append("users[]", selectedUser.id);
      });

      self.scaleOptions.forEach((scaleOption, index) => {
        fd.append("scale-label-" + scaleOption.number, scaleOption.label);
      });

      if (self.research.id) {
        fd.append("id", self.research.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    getResearchCycles() {
      const self = this;
      const api = self.$store.state.api + "researchcycles?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.cycles = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getAnonymityLevels() {
      const self = this;
      const api = self.$store.state.api + "anonymity-levels?paginated=false";
      self.$http
        .get(api)
        .then((response) => {
          self.anonymity_levels = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getResearchEssay: function (id) {
      let self = this;
      let api = self.$store.state.api + "researches/" + id;

      self.$http
        .get(api)
        .then((response) => {
          self.research = response.data.data[0];
          self.research.switch = self.research.select_essay == 1 ? false : true;
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        title: "title",
        dimension_id: "dimension[name]",
        type_id: "type[name]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
    getResearch(id) {
      const self = this;
      const api = self.$store.state.api + "researches/" + id + "?with[]=asks";
      self.$http
        .get(api)
        .then((response) => {
          let research = response.data.data[0];
          for (let i = 0; i < 5; i++) {
            let scaleOption = self.scaleOptions.find((x) => x.number == i);
            if (scaleOption) {
              scaleOption.label = research["scale-label-" + i];
            }
          }

          research.asks.forEach((ask) => {
            self.selectedAsks.push(ask);
          });
          research.apply_start_date = this.revertDateTime(
            research.apply_start_date
          );
          research.apply_end_date = this.revertDateTime(
            research.apply_end_date
          );
          research.analisys_start_date = this.revertDateTime(
            research.analisys_start_date
          );
          research.analisys_end_date = this.revertDateTime(
            research.analisys_end_date
          );
          research.disclosure_start_date = this.revertDateTime(
            research.disclosure_start_date
          );
          research.disclosure_end_date = this.revertDateTime(
            research.disclosure_end_date
          );
          research.action_start_date = this.revertDateTime(
            research.action_start_date
          );
          research.action_end_date = this.revertDateTime(
            research.action_end_date
          );

          self.research = research;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getPreMadeResearch() {
      const self = this;
      const api = self.$store.state.api + "myPreMadeResearches";
      self.$http
        .get(api)
        .then((response) => {
          self.preMadeResearches = response.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    getUsers(id) {
      const self = this;
      const api =
        self.$store.state.api + "researches/" + id + "?with[]=research_users";
      self.$http
        .get(api)
        .then((response) => {
          let research = response.data.data[0];
          self.selectedUsers = research.research_users.map((item) => ({
            ...item,
            id: item.user_id,
          }));
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    self.getResearchCycles();
    self.getAnonymityLevels();
    if (self.$route.params.id) {
      self.getResearch(self.$route.params.id);
      self.getUsers(self.$route.params.id);
    }
    self.getPreMadeResearch();
  },
  components: {
    BaseCrud,
  },
};
</script>
<style>
.ck-content {
  height: 124px !important;
}

.nav-item > .active {
  color: #28a745 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Research/Research.vue